import { render, staticRenderFns } from "./DetailBookingTablePriceTip.vue?vue&type=template&id=745bf331&functional=true&"
import script from "./DetailBookingTablePriceTip.vue?vue&type=script&lang=js&"
export * from "./DetailBookingTablePriceTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports